import React from 'react';

import Text, { TextType, TextProps } from 'components/typography/text';

const ActionLarge: React.FC<React.PropsWithChildren<TextProps>> = (props) => (
  <Text
    type={TextType.ACTION_LARGE}
    isExtended={props.isExtended}
    isResponsive={props.isResponsive || true}
    {...props}
  >
    {props.children}
  </Text>
);

export default ActionLarge;
